/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SearchResources200ResponseTablesInnerSnapshots {
  'latestSnapshotId'?: string;
  'latestSnapshotISODate'?: string;
  'totalSnapshots'?: number;
  'latestSnapshotVaultId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "latestSnapshotId",
      "baseName": "latestSnapshotId",
      "type": "string",
      "format": ""
    },
    {
      "name": "latestSnapshotISODate",
      "baseName": "latestSnapshotISODate",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalSnapshots",
      "baseName": "totalSnapshots",
      "type": "number",
      "format": ""
    },
    {
      "name": "latestSnapshotVaultId",
      "baseName": "latestSnapshotVaultId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResources200ResponseTablesInnerSnapshots.attributeTypeMap;
  }

  public constructor() {
  }
}

